import useMiniScentModel from "./useMiniScentModel";
import MiniScentView from "./MiniScentView";

const MiniScentPage = () => {
  const model = useMiniScentModel();
  return <MiniScentView {...model} />;
};

export default MiniScentPage;
